import React, {useState} from 'react';
import styles from './Calendar.module.css';

interface CalendarProps {
    selectedDate: Date;
    onDateSelect: (date: Date) => void;
}

//달력 컴포넌트
export const Calendar: React.FC<CalendarProps> = ({selectedDate, onDateSelect}) => {
    const [currentMonth, setCurrentMonth] = useState<Date>(new Date());

    const months = ['January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'];
    const weekDays = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

    //해당 월의 총 일수 반환
    const getDaysInMonth = (date: Date): number => {
        return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    };

    //해당 월 1일의 요일 반환
    const getFirstDayOfMonth = (date: Date): number => {
        return new Date(date.getFullYear(), date.getMonth(), 1).getDay();
    };

    //달력에 표시될 날짜 배열 생성
    const generateCalendarDays = (): (number | null)[] => {
        const daysInMonth = getDaysInMonth(currentMonth);
        const firstDay = getFirstDayOfMonth(currentMonth);
        const calendarDays: (number | null)[] = [];

        //첫 주 빈 날짜 null 반환
        for (let i = 0; i < firstDay; i++) {
            calendarDays.push(null);
        }
        //이번 달 날짜 추가
        for (let i = 1; i <= daysInMonth; i++) {
            calendarDays.push(i);
        }

        return calendarDays;
    };

    //날짜 선택
    const handleDateClick = (day: number): void => {
        const newDate = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), day);
        newDate.setHours(0, 0, 0, 0);
        onDateSelect(newDate);
    };

    //저번 달 이동
    const handlePrevMonth = (): void => {
        const newDate = new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1);
        setCurrentMonth(newDate);
    };

    //다음 달 이동
    const handleNextMonth = (): void => {
        const newDate = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1);
        setCurrentMonth(newDate);
    };

    //저번 해 이동
    const handlePrevYear = (): void => {
        const newDate = new Date(currentMonth.getFullYear() - 1, currentMonth.getMonth());
        setCurrentMonth(newDate);
    };

    //다음 해 이동
    const handleNextYear = (): void => {
        const newDate = new Date(currentMonth.getFullYear() + 1, currentMonth.getMonth());
        setCurrentMonth(newDate);
    };

    return (
        <div className={styles.calendar}>
            <div className={styles.calendarHeader}>
                <div className={styles.yearControl}>
                    {/*저번 해 버튼*/}
                    <button
                        type="button"
                        onClick={handlePrevYear}
                        className={styles.controlButton}
                    >
                        ≪
                    </button>
                    {/*선택 해*/}
                    <span className={styles.yearText}>
                        {currentMonth.getFullYear()}
                    </span>
                    {/*다음 해 버튼*/}
                    <button
                        type="button"
                        onClick={handleNextYear}
                        className={styles.controlButton}
                    >
                        ≫
                    </button>
                    {/*저번 달 버튼*/}
                    <button
                        type="button"
                        onClick={handlePrevMonth}
                        className={styles.controlButton}
                    >
                        ＜
                    </button>
                    {/*선택 달*/}
                    <span className={styles.monthText}>
                        {months[currentMonth.getMonth()]}
                    </span>
                    {/*다음 달 버튼*/}
                    <button
                        type="button"
                        onClick={handleNextMonth}
                        className={styles.controlButton}
                    >
                        ＞
                    </button>
                </div>
            </div>

            {/*요일 표시*/}
            <div className={styles.weekDays}>
                {weekDays.map((day, index) => (
                    <div key={index} className={styles.weekDay}>
                        {day}
                    </div>
                ))}
            </div>

            {/*날짜 표시*/}
            <div className={styles.days}>
                {generateCalendarDays().map((day, index) => (
                    <div
                        key={index}
                        className={`
                            ${styles.day}
                            ${day === null ? styles.empty : ''}
                            ${
                            day === selectedDate.getDate() &&
                            currentMonth.getMonth() === selectedDate.getMonth() &&
                            currentMonth.getFullYear() === selectedDate.getFullYear()
                                ? styles.selected
                                : ''
                        }
                        `}
                        onClick={() => day !== null && handleDateClick(day)}
                    >
                        {day}
                    </div>
                ))}
            </div>
        </div>
    );
};
export default Calendar;